export const PHONE_MASK = {
  mask: ['9999-9999', '99999-9999', '99 9999-9999', '99 99999-9999', '99 99 9999-9999', '99 99 99999-9999'],
  showMaskOnFocus: false,
  showMaskOnHover: false,
}

export const CPF_MASK = {
  mask: '999.999.999-99',
  showMaskOnFocus: false,
  showMaskOnHover: false,
}

export const CNPJ_MASK = {
  mask: ['A|9{2}.A|9{3}.A|9{3}/A|9{4}-9{2}'],
  showMaskOnFocus: false,
  showMaskOnHover: false,
}

export const RUT_MASK = {
  mask: ['9.999.999-*', '99.999.999-*'],
  showMaskOnFocus: false,
  showMaskOnHover: false,
}
